import z from "zod/v4";

/**
 * Matches the Rust PredepositRewardsResponse struct
 */
export const PredepositUsdcRewardsSchema = z.object({
  account: z.string(),
  usdc_reward: z.number(),
});

export type PredepositUsdcRewards = z.infer<typeof PredepositUsdcRewardsSchema>;
